import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback, useState } from 'react';
import { getSettingsOverridableConfigFlags } from '../../../config';
import { ExperimentalSettingItem } from './experimentalSettingItem';
/**
 * "Experimental" settings are config flags that are set to be overridable via the Settings modal, and therefore are
 * exposed to the user as something they can test out.
 */
export const ExperimentalSettingsContainer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const onClickExperimental = useCallback(() => {
        setIsOpen(true);
    }, []);
    const settingsOverridableConfigFlags = getSettingsOverridableConfigFlags();
    if (!settingsOverridableConfigFlags.length) {
        return null;
    }
    if (!isOpen) {
        return (_jsx(Button, { variant: 'contained', onClick: onClickExperimental, children: "Experimental Settings" }));
    }
    return (_jsx(_Fragment, { children: settingsOverridableConfigFlags.map((configFlag) => (_jsx(ExperimentalSettingItem, { configFlag: configFlag }, configFlag))) }));
};
